import { createGlobalStyle } from 'styled-components'

export const SidebarAgentesOverrides = createGlobalStyle`
  .sidebar-agentes {
    background: transparent !important;
    border-radius: 32px;
    margin: 0 auto;
    transition: width 0.3s, box-shadow 0.3s;
    overflow: hidden;
    width: 44px;
    min-width: 44px;
    max-width: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
  }

  .custom-sidebar.sidebar-open .sidebar-agentes {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    margin: 0;
  }

  .sidebar-agentes.expanded {
    width: calc(100% - 20px);
    min-width: calc(100% - 20px);
    max-width: calc(100% - 20px);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
  }

  .custom-sidebar.sidebar-open .sidebar-agentes.expanded {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    box-shadow: none;
    margin: 0;
  }

  .agentes-expanded-collapsed {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 20px;
    min-height: 40px;
    width: 100%;
  }

  .agentes-expanded-collapsed.active {
    background-color: transparent !important;
    width: 100%;
    border-radius: 12px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .agentes-header-expanded-collapsed {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    transition: background 0.2s;
    border-radius: 8px;
    padding: 4px;
  }

  .agentes-header-expanded-collapsed:hover {
    background: #dcdddf;
    color: #2c2c2d !important;
  }

  .agentes-expanded {
    background-color: transparent !important;
    border-radius: 12px !important;
    margin: 0 10px;
    width: calc(100% - 20px);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 0;
  }

  .agentes-expanded.active {
    background-color: #ffffff !important;
    border-radius: 12px !important;
  }

  .agentes-header-expanded {
    background-color: transparent;
    border-radius: 12px !important;
    padding: 10px 7px !important;
    margin-right: 10px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: background 0.2s;
  }

  .agentes-header-expanded.active {
    background-color: transparent !important;
    border-radius: 12px !important;
    padding: 10px 4px !important;
    margin-right: 10px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .agentes-header-content {
    display: flex;
    margin-left: 8px;
    align-items: center;
    gap: 12px;
    flex: 1;
    transition: background 0.2s;
    border-radius: 12px;
    padding: 4px;
  }

  .agentes-header-content:hover {
    background: #dcdddf;
  }

  .agentes-title-expanded {
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #7b7b7d;
    flex: 1;
    white-space: nowrap;
    transition: color 0.2s;
  }

  .agentes-title-expanded.active {
    color: #2c2c2d !important;
  }

  .agentes-expanded .agentes-title-expanded {
    color: #7b7b7d;
  }

  .agentes-arrow-btn {
    background: none;
    border: none;
    padding: 0;
    margin-left: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: transform 0.3s;
  }

  .agentes-list-expanded {
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: transparent;
    max-width: 249px;
  }

  .agentes-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .agente-item {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-radius: 16px;
    transition: background 0.2s;
    cursor: pointer;
    box-sizing: border-box;
    margin: 2px 0;
  }

  .agente-item:hover {
    background: rgba(255, 255, 255, 0.7);
  }

  .agente-avatar-container {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .agente-avatar-expanded {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    border: none;
  }

  .agente-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 6px;
    box-sizing: border-box;
    max-width: calc(100% - 48px);
  }

  .agente-nome {
    width: 100%;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
  }

  .agente-nome.interativo {
    color: #2c2c2d;
  }
`
